import apiClient from './apiClient';


export const applyLoan = async (loanData) => {
  try {
    const token = localStorage.getItem('token');

    const response = await apiClient.post(
      'Loan/apply',
      loanData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    return response.data; // loanId
  } catch (error) {
    console.error('Loan apply failed:', error);
    throw error;
  }
};

export const getLoansByUser = async (userId) => {
    try {
      const token = localStorage.getItem('token');
      const response = await apiClient.get(`UserLoan/${userId}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    //   console.log("API RESPONSE:", response.data);
    return response.data;

    } catch (error) {
      console.error('Fetching customer details failed:', error);
      throw error;  // Optionally rethrow the error if you want it to propagate
    }
  };

  export const getAllLoans = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await apiClient.get("AdminLoan", {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });
    //   console.log("API RESPONSE:", response.data);
    return response.data;

    } catch (error) {
      console.error('Fetching customer details failed:', error);
      throw error;  // Optionally rethrow the error if you want it to propagate
    }
  };

export const generatePaymentLink = async (loanId) => {
  try {
    const token = localStorage.getItem('token');

    const response = await apiClient.post(
      `SendPaymentLink`,
      {
        loanApplicationId: loanId
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Generating payment link failed:', error);
    throw error; // rethrow if you want the caller to handle it
  }
};

